import React from "react";
import { BRAND } from "../data/content";

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-10 border-t border-[var(--vw-border)] bg-[var(--vw-bg)]" data-testid="vw-footer">
      <div className="vw-container">
        {/* Massive brand strip */}
        <div className="mb-16 border-b border-[var(--vw-border)] pb-12 overflow-hidden">
          <div className="font-display leading-none tracking-tighter text-[16vw] md:text-[13vw] lg:text-[11vw]">
            <span className="vw-text-gradient">Vaw</span>
            <span className="text-[var(--vw-text)]">World</span>
            <span className="text-[var(--vw-cyan)]">.</span>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10 mb-16">
          <div className="col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)] mb-4">
              THE STUDIO
            </div>
            <p className="text-[var(--vw-text-dim)] leading-relaxed max-w-sm mb-6">
              A full-stack animation studio building blockbuster-quality worlds — with the production economics your board approves.
            </p>
            <div className="flex items-center gap-3">
              {[
                { label: "Vimeo", href: "https://vimeo.com/vawworldd", icon: "M23.977 6.416c-.105 2.338-1.735 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.4 0-2.588-1.294-3.553-3.881L5.322 11.4C4.603 8.816 3.834 7.522 3.01 7.522c-.179 0-.806.378-1.881 1.132L0 7.197c1.185-1.044 2.351-2.088 3.501-3.128C5.08 2.701 6.266 1.984 7.055 1.91c1.867-.18 3.016 1.1 3.447 3.838.465 2.953.789 4.789.971 5.507.539 2.45 1.131 3.674 1.776 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.612-2.061-.574 0-1.167.121-1.777.391 1.186-3.868 3.434-5.757 6.762-5.637 2.473.06 3.628 1.664 3.478 4.797z" },
                { label: "LinkedIn", href: "https://linkedin.com/company/vawworldanimationstudios", icon: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" },
                { label: "Twitter", href: "https://twitter.com/vawworldstudios", icon: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" },
                { label: "Facebook", href: "https://facebook.com/vawworldstudios", icon: "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 011.141.195v3.325a8.623 8.623 0 00-.653-.036 26.805 26.805 0 00-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 00-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647z" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 grid place-items-center border border-[var(--vw-border-strong)] text-[var(--vw-text-dim)] hover:text-[var(--vw-cyan)] hover:border-[var(--vw-cyan)] transition-colors"
                  data-testid={`vw-social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d={s.icon}/>
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <FooterCol title="Studio" links={[
            ["Services", "#services"],
            ["Pipeline", "#pipeline"],
            ["Showreel", "#showreel"],
            ["Portfolio", "#portfolio"],
            ["Originals", "#originals"],
          ]} />
          <FooterCol title="Company" links={[
            ["About", "#top"],
            ["FAQs", "#faqs"],
            ["Contact", "#contact"],
            ["Careers", "#contact"],
          ]} />
          <FooterCol title="Legal" links={[
            ["Privacy", "#"],
            ["Terms", "#"],
            ["Cookies", "#"],
            ["NDA Sample", "#contact"],
          ]} />
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[var(--vw-border)] pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)]">
          <div className="flex items-center gap-4">
            <span>© 2013 — 2026 VawWorld Studios</span>
            <span className="w-4 h-px bg-[var(--vw-border-strong)]" />
            <span>All rights reserved</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-[var(--vw-cyan)] vw-blink" />
            <span>Currently accepting Q1 2026 productions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)] mb-4">
        {title}
      </div>
      <ul className="space-y-2.5">
        {links.map(([label, href]) => (
          <li key={label}>
            <a
              href={href}
              className="text-sm text-[var(--vw-text-dim)] hover:text-[var(--vw-cyan)] transition-colors"
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
